import http from '../axios';
import { HOMEPAGE_NAV_OPEN_MODULE_CODES } from '@/constants/homepageOpenModules';

export function getBannerInfo(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/banner/get', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getRecommend(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/category/recommend', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getLatestWares(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('post', '/jdig/search/latestWares', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getRecommendWares(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('post', '/jdig/recommend/mku/list', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getHomeSort(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/settings/homepage', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getBrowsingVisited(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/browsing/get', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

interface HomePageModulesResponse {
  success: boolean;
  value: {
    modules?: any[];
    data: {
      modules: any[];
    };
  };
  message?: string;
}

export function getHomePageModules(params: any = {}): Promise<HomePageModulesResponse> {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/settings/v2/homepage', params, false, true).then(
      res => {
        resolve(res as HomePageModulesResponse);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getHomepageConfigStatus(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/settings/v2/homepage/status', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

/**
 * 使用默认模板初始化当前登录客户的首页CMS配置。
 * 该接口只在状态接口返回 0 时调用，避免覆盖已有的手动配置或重复初始化过的配置。
 */
export function initHomepageDefaultConfig(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('post', '/jdig/settings/v2/homepage/defaultInit', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export interface HomepageOpenModulesResponse {
  success: boolean;
  code?: string;
  msg?: string;
  value?: Record<string, any>;
}

/** 按 Open 模块编码按需加载首页配置（热搜词、推荐文字链等） */
export function getHomepageOpenModules(
  moduleCodes: string[] = [...HOMEPAGE_NAV_OPEN_MODULE_CODES],
): Promise<HomepageOpenModulesResponse> {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/settings/v2/homepage/openModules', { moduleCodes }, false, true).then(
      res => {
        resolve(res as HomepageOpenModulesResponse);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getThemeZoneProducts(params: {
  subModuleId: number;
  mkuIds?: Array<string | number>;
  catId?: string | number;
}): Promise<any> {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/settings/v2/themeZone', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
